import { Path, Svg } from 'react-native-svg'

// eslint-disable-next-line no-relative-import-paths/no-relative-import-paths
import { createIcon } from '../factories/createIcon'

export const [PlusCircle, AnimatedPlusCircle] = createIcon({
  name: 'PlusCircle',
  getIcon: (props) => (
    <Svg viewBox="0 0 16 16" fill="none" {...props}>
      <Path
        d="M8.00004 1.33334C4.32004 1.33334 1.33337 4.32001 1.33337 8.00001C1.33337 11.68 4.32004 14.6667 8.00004 14.6667C11.68 14.6667 14.6667 11.68 14.6667 8.00001C14.6667 4.32001 11.68 1.33334 8.00004 1.33334ZM10.3334 8.50001H8.50004V10.3333C8.50004 10.6067 8.27337 10.8333 8.00004 10.8333C7.72671 10.8333 7.50004 10.6067 7.50004 10.3333V8.50001H5.66671C5.39337 8.50001 5.16671 8.27334 5.16671 8.00001C5.16671 7.72668 5.39337 7.50001 5.66671 7.50001H7.50004V5.66668C7.50004 5.39334 7.72671 5.16668 8.00004 5.16668C8.27337 5.16668 8.50004 5.39334 8.50004 5.66668V7.50001H10.3334C10.6067 7.50001 10.8334 7.72668 10.8334 8.00001C10.8334 8.27334 10.6067 8.50001 10.3334 8.50001Z"
        fill="currentColor"
      />
    </Svg>
  ),
})
